import { router } from "expo-router";
import i18next from "./lib/i18n";

export const getBaseCacheKey = ({
	orgId,
	projectId,
	appId,
}: {
	orgId: number;
	projectId: number;
	appId: string;
}) => {
	return `org-${orgId}:proj-${projectId}:app-${appId}`;
};

export const handleNavigateBack = (parentRoute: string) => {
	if (router.canGoBack()) {
		router.back();
	} else {
		router.replace(parentRoute as never);
	}
};

export const isI18nKeyExists = (key: string) => {
	return i18next.exists(key);
};
